module.exports = __webpack_public_path__ + "img/01_Tiermedizinische_Praxisassistentin_Foto_2022.c1bf65c9.jpg";